export let LEAD_SCORES = {
  'beaconview-viewed': 1,
  'linkclick-clicked': 3,
  'websitevisited-visited': 2,
  'adclick-clicked': 2,
  'attachmentview-viewerlaunched': 4,
  'attachmentdownload-downloaded': 4,
  'myvideoactivity-myplayerlaunched': 4
};
